(function () {
  // This file is loaded globally from layout/theme.liquid AND by a few sections that predate
  // that. Without this guard the IIFE runs twice, binds two submit handlers to every form, and
  // sends two signups per click. Do not remove it when tidying the section script tags.
  if (window.__pfInterestInit) return;
  window.__pfInterestInit = 1;

  var cfg = window.PF_KLAVIYO || {};
  if (!cfg.key || !cfg.list) return;
  var base = 'https://a.klaviyo.com/client/', q = '?company_id=' + encodeURIComponent(cfg.key);
  var H = { 'Content-Type': 'application/json', 'revision': '2025-01-15' };
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var ENT = { '&': '&amp;', '<': '&lt;', '>': '&gt;' };

  // Confirmations are written with innerHTML and carry the product name, the flavour names and,
  // where a form overrides it, a whole line. All of those come from theme settings a merchant
  // types. Escape them.
  function esc(s) { return String(s).replace(/[&<>]/g, function (c) { return ENT[c]; }); }

  // What this device has already sent, keyed by email AND by the specific thing signed up for:
  // 'waitlist:home', 'product:Lollies'. Scoped per thing on purpose. An earlier version kept a
  // single flag per email, which meant joining the waitlist suppressed the Lollies pre-order
  // event for that person forever after, so per-product demand was never recorded.
  // Klaviyo's public client API answers the same whether or not the profile already existed, and
  // there is no server here to ask, so this is a per-device record only: it catches the common
  // case (same person, same phone, taps Join twice) and misses a new device.
  function readDone() {
    try { return JSON.parse(localStorage.getItem('pf-done') || '{}'); } catch (e) { return {}; }
  }
  function doneKey(kind, label) { return kind + ':' + (label || '-'); }
  function markDone(email, key) {
    try {
      var d = readDone(), e = email.toLowerCase();
      d[e] = d[e] || {};
      d[e][key] = 1;
      localStorage.setItem('pf-done', JSON.stringify(d));
      localStorage.setItem('pf-email', email);
    } catch (err) {}
  }
  function hasDone(email, key) {
    var d = readDone()[email.toLowerCase()];
    return !!(d && d[key]);
  }

  var remembered = '';
  try { remembered = localStorage.getItem('pf-email') || ''; } catch (e) {}

  function post(path, body) {
    return fetch(base + path + q, { method: 'POST', headers: H, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); });
  }
  function subscribe(email, source) {
    return post('subscriptions', { data: { type: 'subscription', attributes: {
      custom_source: source,
      profile: { data: { type: 'profile', attributes: { email: email,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
    }, relationships: { list: { data: { type: 'list', id: cfg.list } } } } });
  }
  // All three events below are the same request with a different metric name, so they share this.
  function event(name, email, props) {
    return post('events', { data: { type: 'event', attributes: {
      properties: props,
      metric: { data: { type: 'metric', attributes: { name: name } } },
      profile: { data: { type: 'profile', attributes: { email: email } } }
    } } });
  }
  // Per-product demand. One of these per product a person asks about, so Lollies and Kittles
  // can be counted against each other.
  function interest(email, product, choices, page) {
    return event('Product interest', email, {
      kind: 'product', product: product,
      choices: choices, choices_text: choices.join(', '), page: page
    });
  }
  // General waitlist, no product attached. 'source' is where it came from: home, dialog,
  // password, home-nudge.
  function waitlist(email, source, page) {
    return event('Waitlist signup', email, { kind: 'waitlist', source: source, page: page });
  }
  // A separate metric, so a second tap on the same thing never inflates the signup count.
  // Carries kind and label so a repeat pre-order stays separable from a repeat waitlist tap.
  function checkedIn(email, kind, label, page) {
    return event('Waitlist check-in', email, { kind: kind, source: label, page: page });
  }

  // Four distinct confirmations. The waitlist pair and the pre-order pair must not share
  // phrasing: someone who does both in one visit sees two of these, and a repeat sees a third.
  // One running joke (the cat as an unhurried clerk), a different clerical verb in each line.
  // A form overrides these with data-done / data-done-again, which the reservation forms do,
  // because "pencilled you in" does not say that no money changed hands.
  function confirmation(isWaitlist, again, label, choices) {
    if (isWaitlist) {
      return again
        ? 'Already on the list. The cat checked twice, just to be sure.'
        : 'You’re on the list. The cat is filing your papers now.';
    }
    if (again) return 'Still ' + esc(label) + ', then. The cat has underlined it this time.';
    return esc(label) + ' it is'
      + (choices.length ? ', ' + esc(choices.join(' and ')) + ' noted' : '')
      + '. The cat has pencilled you in, and the cat does not forget.';
  }

  // Announced on the .pi box, bubbling, once a signup has actually saved. The home nudge
  // listens for this to fold itself away and stop asking. Anything else that needs to react to
  // a signup should listen for it too, rather than watching the DOM for the confirmation.
  function announce(box, kind, label, again) {
    try {
      box.dispatchEvent(new CustomEvent('pf:joined', {
        bubbles: true,
        detail: { kind: kind, label: label, again: again }
      }));
    } catch (e) {}
  }

  function bind(box) {
    if (box.getAttribute('data-pi-bound')) return;
    box.setAttribute('data-pi-bound', '1');

    var btn = box.querySelector('.pi-open'), form = box.querySelector('.pi-form');
    if (!form) return;
    var input = form.querySelector('input[type=email]'), msg = form.querySelector('.pi-msg'), go = form.querySelector('button[type=submit]');
    if (!input || !go) return;
    var isWaitlist = box.getAttribute('data-kind') === 'waitlist';
    var kind = isWaitlist ? 'waitlist' : 'product';
    var label = isWaitlist ? (box.getAttribute('data-source') || 'site') : box.getAttribute('data-product');
    var saidDone = box.getAttribute('data-done');
    var saidAgain = box.getAttribute('data-done-again');
    var key = doneKey(kind, label);
    var goLabel = go.textContent;
    if (remembered) input.value = remembered;

    function shut() {
      form.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }

    if (btn) {
      btn.addEventListener('click', function () {
        var open = form.hidden; form.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) (input.value ? go : input).focus();
      });
    } else {
      form.hidden = false;
    }

    // A popover floats over the page, so it has to be dismissible the way a popover is. An
    // inline form does not: nothing overlaps it and closing it costs the reader their place.
    if (btn && box.className.indexOf('pi-pop') > -1) {
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !form.hidden) { shut(); btn.focus(); }
      });
      document.addEventListener('click', function (e) {
        if (!form.hidden && !box.contains(e.target)) shut();
      });
    }

    function done(html) {
      form.innerHTML = '<p class="pi-done" role="status" tabindex="-1"><i class="curl-dot" aria-hidden="true"></i>' + html + '</p>';
      var d = form.querySelector('.pi-done'); if (d) d.focus();
      if (btn) btn.hidden = true;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!EMAIL.test(email)) { if (msg) { msg.hidden = false; msg.textContent = 'Enter a full email address.'; } input.focus(); return; }
      var choices = Array.prototype.map.call(form.querySelectorAll('.pi-opts input:checked'), function (c) { return c.value; });
      var C = window.PFCurl; if (msg) msg.hidden = true;
      var again = hasDone(email, key);
      if (C) { C.start(go); } else { go.disabled = true; go.textContent = 'Noting…'; }

      subscribe(email, (document.title || 'Site') + ': ' + label)
        .then(function () {
          var ev = again
            ? checkedIn(email, kind, label, location.pathname)
            : (isWaitlist ? waitlist(email, label, location.pathname)
                          : interest(email, label, choices, location.pathname));
          return ev.catch(function () {});
        })
        .then(function () { return C ? C.success(go) : null; })
        .then(function () {
          markDone(email, key);
          var said = again ? saidAgain : saidDone;
          if (said) {
            // The override is one sentence for every choice, so the chosen option is named
            // ahead of it rather than lost.
            done((choices.length ? esc(choices.join(' and ')) + '. ' : '') + esc(said));
          } else {
            done(confirmation(isWaitlist, again, label, choices));
          }
          announce(box, kind, label, again);
        }, function () {
          return (C ? C.fail(go) : Promise.resolve()).then(function () {
            go.disabled = false; go.textContent = goLabel;
            if (msg) { msg.hidden = false; msg.textContent = "Couldn't save that just now. Try again in a moment."; }
          });
        });
    });
  }

  function scan() { Array.prototype.forEach.call(document.querySelectorAll('.pi'), bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();